import HomeView from "./views/Home";
import SchedulingNew from "./containers/SchedulingNew";
import ListUsers from "./containers/ListUsers";
import ManageUser from "./containers/ManageUser";
import ApproveUsers from "./containers/ApproveUsers";
import ScheduleConfig from "./containers/ScheduleConfig";
import Scheduling from "./containers/Scheduling";
import SchedulingStatus from "./containers/SchedulingStatus";
import BlankView from "./views/Blank";

export default {
  root: (profile, groups) => {
    if (groups && groups.length === 1 && groups.includes("user")) {
      return "/unassigned";
    }
    switch (profile) {
      case "transporter":
        // return "/trocar-documentos/carregamentos-transportadoras";
        return `/agendamento`;
      case "transporter_invoice":
        return "/transport-invoices/transporter-homepage";
      case "backoffice":
        if (groups.includes("cargill_transports")) {
          // return "/cargill-transports/enviar-documentos";
          // return "/trocar-documentos/validar-documentos";
          return "/trocar-documentos/backoffice-homepage";
        }
        // return "/trocar-documentos/validar-documentos";
        return "/trocar-documentos/backoffice-homepage";
      case "backoffice_invoice":
        return "/transport-invoices/backoffice-homepage";
      case "support":
        // return "/suporte/ordens-carregamento";
        return "/trocar-documentos/backoffice-homepage";
      case "farmer":
        // return `/trocar-documentos/carregamentos-fazenda`;
        return `/agendamento`;
      case "check_in_agent":
        return `/agendamento`;
      case "client":
      case "vendor":
        return `/agendamento`;
      case "warehouse":
        return  `/trocar-documentos/carregamentos-warehouse`;
      default:
        return `/trocar-documentos/carregamentos-motorista`;
    }
  },
  appRoutes: [
    {
      component: HomeView,
      path: "/pontos-de-troca",
      exact: true,
    },
    {
      exact: true,
      path: "/trocar-documentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/gerenciar",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/validar-documentos-transportadoras",
      component: HomeView,
    },
    {
      exact: true,
      path: "/cargill-transports/enviar-documentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/carregamentos-transportadoras",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/acompanhar-status-fazenda",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/carregamentos-fazenda",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/carregamentos-warehouse",
     component: HomeView
    },
    {
      exact: true,
      path: "/trocar-documentos/acompanhar-status-warehouse",
      component: HomeView
    },
    {
      exact: true,
      path: "/trocar-documentos/pesquisar-carregamentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/acompanhar-status-motorista",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/carregamentos-motorista",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/validar-documentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/adicionar-documentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/ocs-com-documentos",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/ocs-canceladas",
      component: HomeView,
    },
    {
      exact: true,
      path: "/trocar-documentos/backoffice-homepage",
      component: BlankView,
    },
    {
      exact: true,
      path: "/transport-invoices/backoffice-homepage",
      component: BlankView,
    },
    {
      exact: true,
      path: "/transport-invoices/transporter-homepage",
      component: BlankView,
    },
    {
      exact: true,
      path: "/agendamento/novo",
      component: SchedulingNew,
    },
    {
      exact: true,
      path: "/agendamento",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/todos",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/agendados",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/fila",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/chamado",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/atendimento",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/cancelados",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/concluidos",
      component: Scheduling,
    },
    {
      exact: true,
      path: "/agendamento/status/:id",
      component: SchedulingStatus,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes/turno",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes/planta",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes/docas",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes/cotaplanta",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes/cotacliente",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/agendamento/configuracoes",
      component: ScheduleConfig,
    },
    {
      exact: true,
      path: "/gerenciar-usuarios/editar-usuario/:id",
      component: ManageUser,
    },
    {
      exact: true,
      path: "/gerenciar-usuarios/listar-usuarios",
      component: ListUsers,
    },
    {
      exact: true,
      path: "/gerenciar-usuarios/novo-usuario",
      component: ManageUser,
    },
    {
      exact: true,
      path: "/gerenciar-usuarios/aprovar-usuarios",
      component: ApproveUsers,
    },
    {
      exact: true,
      path: "/pontos-de-troca/lista",
      component: HomeView,
    },
    {
      exact: true,
      path: "/pontos-de-troca/rotas-para-pontos-de-troca",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/ordens-carregamento",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/usuarios",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/filiais-destino",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/filiais-origem",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/fazendas-expedidoras",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/fazendas-origem",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/motoristas",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/transportadoras",
      component: HomeView,
    },
    {
      exact: true,
      path: "/suporte/logs",
      component: HomeView,
    },
  ],
};
